// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RVJ-s","title":"styles_title__3MGJw"};